"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DistributorProfileView_1 = __importDefault(require("./DistributorProfileView"));
exports.default = DistributorProfileView_1.default;
